<template>
  <gj-popover
    v-model="visible"
    placement="top"
    title="竞价"
    width="200"
    lazy
    trigger="manual"
    @show="popoverShow">
    <div class="gj-cell-display-switch" slot="reference" @click="showEdit()" v-if="isEdit">
      <i class="el-icon-edit"></i>
    </div>
    <el-form ref="form" :model="form" @submit.native.prevent>
      <el-form-item
        prop="defaultBid"
        :rules="[
          { required: true, message: '请输入调整值', trigger: ['blur', 'change'] },
          $gjReRule(RE.num(2), '请输入最多2位小数的正整数')
        ]">
        <gj-input v-model="form.defaultBid" @keyup.enter.native="confirm()" width="200px">
          <template #prepend>{{ currencySymbol }}</template>
        </gj-input>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin-top: 14px">
      <gj-button :size="'mini'" @click="close()">取消</gj-button>
      <gj-button :size="'mini'" type="primary" @click="confirm()" :loading="loading">确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
  import { formRuleMixin } from "@/minxins";
  export default {
  name: "ad-defaultBid-edit",
  mixins: [formRuleMixin],
  props: {
    value: {},
    isEdit: {
      type: Boolean,
      default: true
    },
    currencySymbol: {
      type: String,
      default: ""
    },
    updateValue: {
        type: Function
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        defaultBid: null
      }
    };
  },
  components: {},
  methods: {
    popoverShow() {
      this.form.defaultBid = this.value.defaultBid || this.value.bid;
    },
    close() {
      this.visible = false
    },
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false;
        this.loading = true
        try {
          const data = await this.updateValue(this.form.defaultBid, this.value)
          this.visible = data
        } finally {
          this.loading = false
        }
      });
      
    },
    showEdit() {
      this.visible = true
    },
  },
  };
</script>

<style scoped lang='scss'>
.el-icon-edit {
  font-size: 13px;
}
/deep/ .el-popover {
  padding: 16PX !important;
}
</style>